import { historyWords as words } from "@/components/history/history-copy";
import { readRosterFile } from "@/lib/registrar-roster-source";
import { useImportTask } from "./useImportTask";

export function useRegistrarRosterBox(rank: number | null = null) {
  return useImportTask("history-import-roster", words.registrarRoster, "registrar_roster", (source, setSource) => {
    const read = async (file: File | undefined) => {
      if (!file) return;
      try {
        const bytes = await file.arrayBuffer();
        const digest = await crypto.subtle.digest("SHA-256", bytes);
        const result = readRosterFile(file.name, new TextDecoder().decode(bytes));
        const hash = Array.from(new Uint8Array(digest), (v) => v.toString(16).padStart(2, "0")).join("");
        setSource({ name: file.name, digest: hash, scope: hash, rows: result.rows, problems: result.problems });
      } catch (e) {
        setSource({ name: file.name, digest: "", rows: [], problems: [e instanceof Error ? e.message : words.thisFileCouldNotBeRead] });
      }
    };
    return <div className="grid gap-3 text-ui">
      <label className="grid gap-2">{words.rosterFile}<input type="file" accept=".csv,.json" onChange={(e) => void read(e.target.files?.[0])} /></label>
      <p>{words.chooseTheFileReviewEachLearnerThenReadADryRunARoster}</p>
      {source && <p>{source.name}: {source.rows.length} {words.sourceRows}</p>}
      {source?.problems.map((problem) => <p role="alert" key={problem}>{problem}</p>)}
    </div>;
  }, undefined, rank).box;
}
